import { AsyncPipe, NgClass, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ChartConfiguration } from 'chart.js';
import { NgChartsModule } from 'ng2-charts';
import { BehaviorSubject } from 'rxjs';

export type CanvasComponentOptions = ChartConfiguration<'line'> & {
  legend?: {
    bottom: boolean;
    left: boolean;
    right: boolean;
    top: boolean;
  };
};

interface Color {
  color?: string;
  hide: boolean;
  id: number;
  label: string;
  type: string;
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, NgStyle, AsyncPipe, NgChartsModule],
  selector: 'aux-canvas-chart',
  styles: [],
  templateUrl: './canvas-chart.component.html',
})
export class CanvasChartComponent {
  colors: Color[] = [];
  defaultChartOptions$ = new BehaviorSubject<CanvasComponentOptions | null>(null);

  @Input() set chartOptions(data: CanvasComponentOptions) {
    this.colors = [];
    data?.data.datasets?.forEach((x, index) => {
      if (x.borderColor) {
        this.colors.push({
          color: x.borderColor?.toString() || '',
          hide: false,
          id: index,
          label: x.label || '',
          type: x.type || '',
        });
      }
    });

    this.colors = this.colors.sort((x, y) => {
      return x.type === 'bar' && y.type === 'line'
        ? -1
        : y.type === 'bar' && x.type === 'line'
          ? 1
          : 0;
    });
    this.defaultChartOptions$.next({ ...data });
  }

  legendAction(color: Color) {
    this.colors = this.colors.map((x) => {
      if (x.color === color.color) {
        return { ...x, hide: !color.hide };
      }

      return x;
    });

    const options = this.defaultChartOptions$.getValue();

    if (!options) {
      return;
    }

    const data = options.data.datasets.map((x, index) => {
      if (index === color.id) {
        return { ...x, hidden: !color.hide };
      }

      return x;
    });

    this.defaultChartOptions$.next({
      ...options,
      data: {
        ...options.data,
        datasets: data,
      },
    });
  }
}
